import { default as indexV0v4Loh2CmMeta } from "/builds/nht4944308/brands/afrimarkets/webapp/pages/conversations/[sid]/index.vue?macro=true";
import { default as _91sid_93zSI1R6ieASMeta } from "/builds/nht4944308/brands/afrimarkets/webapp/pages/conversations/[sid].vue?macro=true";
import { default as index65wf0C4Jv1Meta } from "/builds/nht4944308/brands/afrimarkets/webapp/pages/index.vue?macro=true";
import { default as indexhXbfxOfNsAMeta } from "/builds/nht4944308/brands/afrimarkets/webapp/pages/login/agent/index.vue?macro=true";
import { default as agentlY6O3kJSBuMeta } from "/builds/nht4944308/brands/afrimarkets/webapp/pages/login/agent.vue?macro=true";
export default [
  {
    name: _91sid_93zSI1R6ieASMeta?.name,
    path: "/conversations/:sid()",
    component: () => import("/builds/nht4944308/brands/afrimarkets/webapp/pages/conversations/[sid].vue").then(m => m.default || m),
    children: [
  {
    name: "conversations-sid",
    path: "",
    component: () => import("/builds/nht4944308/brands/afrimarkets/webapp/pages/conversations/[sid]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/nht4944308/brands/afrimarkets/webapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: agentlY6O3kJSBuMeta?.name,
    path: "/login/agent",
    component: () => import("/builds/nht4944308/brands/afrimarkets/webapp/pages/login/agent.vue").then(m => m.default || m),
    children: [
  {
    name: "login-agent",
    path: "",
    component: () => import("/builds/nht4944308/brands/afrimarkets/webapp/pages/login/agent/index.vue").then(m => m.default || m)
  }
]
  }
]